import { uploadAcceptLabel } from '@peles/shared';

/**
 * "Please send PDF." — what an upload link will accept, in words.
 *
 * Its own component rather than a line inside the upload page because the same
 * sentence belongs beside every place a file is asked for, and because it owns
 * a decision: **an unrestricted link says nothing at all**. Rendering "any
 * file" would be noise on the majority of links, which carry no restriction —
 * so this returns null and the page stays quiet.
 */
export interface AcceptedFileTypesNoteProps {
  /** Keys from UPLOAD_FILE_TYPES; empty or absent means anything goes. */
  fileTypes: readonly string[] | null | undefined;
  className?: string;
}

export function AcceptedFileTypesNote({
  fileTypes,
  className = 'mt-2 text-xs text-gray-500',
}: AcceptedFileTypesNoteProps) {
  const label = uploadAcceptLabel(fileTypes);
  if (!label) return null;

  return (
    <p className={className} data-testid="accepted-types">
      Please send {label}.
    </p>
  );
}
